<div class="tn-dropdown-group hover-dropdown"
  (click)="toggle()"
  [ngClass]="{'force-display': isDropdownToggled}">
  <button class="tn-dropdown-button">
    <i class="fa fa-fw fa-angle-down"></i>
  </button>
</div>